import { useEffect } from "react";
//#region Styles
import {
    Container, 
    ContainerTimeBlock 
} from "./styles";
//#endregion
//#region Components
import CustomTime from "components/CustomTimePicker/CustomTimePicker";
import ErrorMessage from "components/ErrorMessage/ErrorMessage";
import InactivityBlock from "views/components/Duration/InactivityBlock/InactivityBlock";
//#endregion

const TimeForDays = ({
    allDays, 
    duration, 
    handlerChange,
    errors,
    showInactivitySummaryCard,
    ratioMinutesTimeForTimePickers,
    disableControlsForNoLongerDraft,
}) => {
    const { time, date } = duration;
    const setNewTime = (dayId, field, value, errorValue) => {
        const newTime = { form: [], errors: [] };
        time.forEach((timeItem, idx) => {
            if (timeItem.dayId !== dayId) {
                newTime.form.push(timeItem);
                newTime.errors.push(errors[idx]);
                return;
            }
            newTime.form.push({
                ...timeItem,
                [field]: value
            });
            const currentStartTime = field === "start" ? value : timeItem.start;
            const currentEndTime = field === "end" ? value : timeItem.end;
            newTime.errors.push({
                ...errors[idx], 
                [field]: errorValue,
                areInvalidTimes: (
                    currentStartTime >= 0 && 
                    currentEndTime >= 0 && 
                    currentStartTime >= currentEndTime
                )
            });
        });
        return newTime;
    }
    const changeTimeItem = (dayId, field, value, errorValue) => {        
        handlerChange(setNewTime(dayId, field, value, errorValue));
    }
    const changeInactivity = (dayId, value, errorValue) => {
        changeTimeItem(dayId, "inactivity", value, errorValue);
    }
    return (
        <Container> 
            {[...time].sort((a, b) => {
                return a.dayId - b.dayId;
            }).map(({ 
                dayId, 
                ...timeItem  
            }, idx) => {
                const day = allDays.find(
                    row => row.id === dayId)?.name;
                const errorsTimeBlock = errors.find(
                    row => row.dayId === dayId);
                return (
                    <TimeBlock 
                        key={idx} 
                        day={day}
                        date={duration.date}
                        time={timeItem}
                        availableDay={dayId}
                        disabled={disableControlsForNoLongerDraft}
                        ratioMinutesTimeForTimePickers={ratioMinutesTimeForTimePickers}
                        showInactivitySummaryCard={showInactivitySummaryCard}
                        onChange={(field, value) => changeTimeItem(dayId, field, value, false)}
                        changeInactivity={(value, errorValue) => changeInactivity(dayId, value, errorValue)}
                        errors={errorsTimeBlock}/>
                );
            })}
        </Container>
    );
}
const TimeBlock = ({
    onChange, 
    day, date,
    time, errors,
    ratioMinutesTimeForTimePickers,
    showInactivitySummaryCard,
    changeInactivity,
    availableDay,
    disabled
}) => {
    return (
        <ContainerTimeBlock>
            <h4>{day}</h4>
            <CustomTime 
                label="Desde:"
                value={time.start}
                onChange={value => onChange("start", value)}
                disabled={disabled}
                error={errors?.start}
                errorText="Es necesario seleccionar una hora inicial."
                ratioMinutesTime={ratioMinutesTimeForTimePickers}/>
            <CustomTime 
                label="Hasta:"
                value={time.end}
                onChange={value => onChange("end", value)}
                disabled={disabled}
                error={errors?.end}
                errorText="Es necesario seleccionar una hora final."
                ratioMinutesTime={ratioMinutesTimeForTimePickers}/>
            <ErrorMessage 
                error={errors?.areInvalidTimes}
                text="Las horas son iguales o la hora de inicio es mayor a la de fin."/>
            {time?.inactivity !== undefined && 
            <InactivityBlock 
                duration={{
                    date,
                    time,
                    availableDay
                }}
                changeInactivity={changeInactivity}
                ratioMinutesTime={ratioMinutesTimeForTimePickers}
                showSummaryCard={showInactivitySummaryCard}
                errors={{
                    time: errors
                }}
                date={date}/>}
        </ContainerTimeBlock>
    );
}

export default TimeForDays
